import React, {ReactElement} from 'react'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'
import OverviewSettlementsAnalytics from '@/pages/Overview/components/OverviewSettlementsAnalytics/OverviewSettlementsAnalytics'
import OverviewPaymentsAnalytics from '@/pages/Overview/components/OverviewPaymentsAnalytics/OverviewPaymentsAnalytics'

export const OverviewBetaTabsContainerStoreSymbol = Symbol('OverviewBetaTabsContainerStore')
export const SettlementsOverviewRangePickerStoreSymbol = Symbol(
    'SettlementsOverviewRangePickerStore'
)
export const PaymentsOverviewRangePickerStoreSymbol = Symbol('PaymentsOverviewRangePickerStore')
export const OverviewSettlementsCurrencySelectStoreSymbol = Symbol(
    'OverviewSettlementsCurrencySelectStore'
)
export const OverviewPaymentsCurrencySelectStoreSymbol = Symbol(
    'OverviewPaymentsCurrencySelectStore'
)
export const PaymentsTypeSelectStoreSymbol = Symbol('PaymentsTypeSelectStore')

export const currencySelectStoreMap: Record<string, symbol> = {
    settlements: OverviewSettlementsCurrencySelectStoreSymbol,
    payments: OverviewPaymentsCurrencySelectStoreSymbol
}

export const rangePickerConfigMap: Record<
    string,
    {
        key: string
        injectableIdentifier: symbol
    }
> = {
    settlements: {
        key: 'settlements',
        injectableIdentifier: SettlementsOverviewRangePickerStoreSymbol
    },
    payments: {
        key: 'payments',
        injectableIdentifier: PaymentsOverviewRangePickerStoreSymbol
    }
}

export const analyticsConfigMap: Record<
    string,
    {
        permissions: string[]
        component: ReactElement
    }
> = {
    settlements: {
        permissions: [PermissionsMap.settlements.read, PermissionsMap.settlements.full],
        component: <OverviewSettlementsAnalytics />
    },
    payments: {
        permissions: [PermissionsMap.pos_payments.read, PermissionsMap.pos_payments.full, PermissionsMap.online_payments.read, PermissionsMap.online_payments.full],
        component: <OverviewPaymentsAnalytics />
    }
}
